import React from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';

const TaxBreakdown = ({ taxes, showDetails = true, className = '' }) => {
    if (!taxes) {
        return null;
    }

    const { gst, pst, totalTaxes, province } = taxes;

    if (totalTaxes > 0) {
        return (
            <div className={`tw-flex tw-flex-col tw-gap-[4px] ${className}`}>
                <div className='tw-flex tw-justify-between tw-text-[14px] tw-leading-[20px] tw-text-gray-600'>
                    <span className='tw-font-medium'>Taxes ({province}):</span>
                </div>

                {/* GST */}
                <div className='tw-flex tw-justify-between'>
                    <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-flex tw-items-center'>
                        GST ({Math.round(gst.rate * 100)}%)
                        {showDetails && !gst.applies && (
                            <span className='tw-text-[12px] tw-text-gray-500 tw-ml-2'>(Individual provider)</span>
                        )}
                    </span>
                    <span
                        className={`tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-font-[500] ${
                            gst.applies ? 'tw-text-black' : 'tw-text-gray-400'
                        }`}
                    >
                        {numeral(gst.amount).format('$0,0.00')}
                    </span>
                </div>

                {/* PST */}
                <div className='tw-flex tw-justify-between'>
                    <span className='tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-flex tw-items-center'>
                        PST ({Math.round(pst.rate * 100)}%)
                        {showDetails && !pst.applies && (
                            <span className='tw-text-[12px] tw-text-gray-500 tw-ml-2'>(Service exempt)</span>
                        )}
                    </span>
                    <span
                        className={`tw-text-[16px] tw-leading-[24px] tw-tracking-[0.15px] tw-font-[500] ${
                            pst.applies ? 'tw-text-black' : 'tw-text-gray-400'
                        }`}
                    >
                        {numeral(pst.amount).format('$0,0.00')}
                    </span>
                </div>
            </div>
        );
    } else {
        // No taxes apply
        return (
            <div className={`tw-flex tw-justify-between ${className}`}>
                <span className='tw-text-[14px] tw-leading-[20px] tw-text-green-600'>
                    ✓ No taxes apply to this service
                </span>
            </div>
        );
    }
};

TaxBreakdown.propTypes = {
    taxes: PropTypes.shape({
        gst: PropTypes.shape({
            rate: PropTypes.number.isRequired,
            amount: PropTypes.number.isRequired,
            applies: PropTypes.bool.isRequired
        }).isRequired,
        pst: PropTypes.shape({
            rate: PropTypes.number.isRequired,
            amount: PropTypes.number.isRequired,
            applies: PropTypes.bool.isRequired
        }).isRequired,
        totalTaxes: PropTypes.number.isRequired,
        province: PropTypes.string.isRequired
    }),
    showDetails: PropTypes.bool,
    className: PropTypes.string
};

export default TaxBreakdown;
